import React from "react";

const Footer = () => {
    return (
        <div className="bg-[#1f1f1f] text-sm p-4 text-center text-white bottom-0">
            Copyright © 2025 Vasantharan K. All Rights Reserved.
        </div>
    );
};

export default Footer;
